var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-color"},[_c('el-color-picker',{attrs:{"clearable":false},model:{value:(_vm.valueData),callback:function ($$v) {_vm.valueData=$$v},expression:"valueData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }